import { getQuery, getLimitOptions } from 'utilities/query';
import templateUrl from './compliant-members.html';

export default {
  templateUrl,
  bindings: {
    companies: '<'
  },
  controller: class CompliantMembersComponent {
    constructor($mdDialog, EventEmitter) {
      'ngInject';

      Object.assign(this, { $mdDialog, EventEmitter });
    }

    $onInit() {
      this.query = getQuery();
      this.limitOptions = getLimitOptions();
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/admin/member-compliance/compliant-members/compliant-members.component.js